// services/AnalyticsServices.js
import axiosInstance from "./AxiosInstance";

export function getAssetStatusDistribution(params = {}) {
  return axiosInstance.get("/api/Analytics/asset-status-distribution/", { params });
}

export function getTopDepartments(params = {}) {
  return axiosInstance.get("/api/Analytics/top-departments/", { params });
}

export function getAssetGrowthTrend(params = {}) {
  return axiosInstance.get("/api/Analytics/asset-growth-trend/", { params });
}

export function getMaintenanceCostByCategory(params = {}) {
  return axiosInstance.get("/api/Analytics/maintenance-cost-by-category/", { params });
}

export function getNearWarrantyExpiry(params = {}) {
  return axiosInstance.get("/api/Analytics/near-warranty-expiry/", { params });
}

export function getAssetRepairTrend(params = {}) {
  return axiosInstance.get("/api/Analytics/asset-repair", { params });
}